// frontend/src/components/matching/SummaryBar.jsx
import StatTiles from "./StatTiles";
import "./Matching.css";

export default function SummaryBar({ summary }) {
  const { total, can_supply, missing, supply_rate } = summary;
  const pctVal = Math.round(supply_rate * 100);
  return (
    <StatTiles
      stats={[
        { label: "Can supply", value: can_supply },
        { label: "Missing", value: missing },
        { label: "Total positions", value: total },
      ]}
    >
      <div className="mt-progress">
        <div
          className="mt-progress-track"
          role="progressbar"
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={Number.isFinite(pctVal) ? pctVal : undefined}
          aria-label="Supply coverage"
        >
          <div className="mt-progress-fill" style={{ width: `${pctVal}%` }} />
        </div>
        <span className="ds-meta">{pctVal} % supply coverage</span>
      </div>
    </StatTiles>
  );
}
